import React from 'react';
import FafsaHelper from '@/pages/modules/FafsaHelper';
import { PublicFooter } from '@/components/public/PublicFooter';

const PublicFafsaHelper: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <main className="flex-1">
        <div className="max-w-6xl mx-auto px-4 py-8">
          <FafsaHelper />
        </div>
      </main>
      <PublicFooter />
    </div>
  );
};

export default PublicFafsaHelper;
